<!--
  Footer
  created by ting.zhou 2017.06.16
  update by wenjie.zhao 2017.06.22
 -->
<template>
  <div class="footer">
    <div class="copy-right"><img src="/imgs/portal/logo_color.png" alt="logo" class="logo">Copyright © 2013-{{ new Date().getFullYear() }}<span> 鼎程（上海）金融信息服务有限公司 </span>致电：400-622-8098<span> <a style="color: #888888" href="https://beian.miit.gov.cn">沪ICP备14012246号-1</a></span></div>
    <div class="contact">
      <div>
        <span class="top">群星金融</span>
        <span @click="topage('about')">公司介绍</span>
        <span @click="topage('news')">群星资讯</span>
      </div>
      <div>
        <span class="top">快速入口</span>
        <span @click="topage('product')">平台产品</span>
        <span @click="topage('service')">供应链金融服务</span>
        <span @click="topage('download')">下载方案</span>
        <span @click="topage('service')">下载白皮书</span>
      </div>
      <div>
        <span class="top">供应链角色</span>
        <span @click="topage('core')">我是上市公司</span>
        <span @click="topage('institution')">我是金融机构</span>
        <span @click="topage('chain','n1')">我是供应商</span>
        <span @click="topage('chain','1n')">我是经销商</span>
      </div>
      <div>
        <span class="top">其他</span>
        <span @click="topage('join')">加入群星</span>
      </div>
      <div class="qrcode">关注群星金融公众号<br>了解一手供应链金融资讯</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    'page': String, // 外层页面路径
    'roleType': String
  },
  methods: {
    topage (way, type) {
      this.$router.push({path: way, query: {page: this.page, roleType: this.roleType, type: type}})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css//utils";
@import "../css/theme-config";
.footer{
  width: 100%;
  color: #ccc;
  user-select: auto;
  @include mediaQuery() {
    height: auto;
  }
  .copy-right{
    font-family:PingFangSC-Regular;
    font-size:12px;
    color:#888888;
    letter-spacing:0;
    line-height:11px;
    text-align:left;
    min-width: 1000px;
    width: 1000px;
    margin: 50px auto 10px;
    .logo{
      display: block;
      width: 79px;
      margin-bottom: 10px;
    }
    span{
      display: inline-block;
      margin: 0 16px;
    }
    @include mediaQuery() {
    }
    @include mediaQuerySmall() {
    }
  }
  .contact{
    min-width: 1000px;
    width: 1000px;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 30px;
    border-top: 1px solid#d6d6d6;
    overflow: hidden;
    div{
      vertical-align: top;
      display: inline-block;
      width: 193px;
      span{
        display: block;
        font-family:PingFangSC-Regular;
        font-size:12px;
        color:#333333;
        letter-spacing:0;
        line-height:12px;
        margin-bottom: 16px;
        cursor: pointer;
      }
    }
    .top{
      font-family:PingFangSC-Medium;
      font-size:12px;
      color:#111111;
      letter-spacing:0;
      line-height:12px;
      font-weight: 700;
      cursor: auto;
    }
    .qrcode{
      font-family:PingFangSC-Regular;
      font-size:12px;
      color:#333333;
      width: 143px;
      float: right;
      padding-bottom: 1.1rem;
      background-repeat: no-repeat;
      background-size: 1rem 1rem;
      background-position: left bottom;
      background-image: url(/imgs/portal/home/wechat@2x.jpg);
      @include media2x(url(/imgs/portal/home/wechat@2x.jpg));
      img{
        display: none;
      }
      @include mediaQuery() {
      }
      @include mediaQuerySmall() {
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?d4f6091c